// extracted by mini-css-extract-plugin
export default {"sharedWithMeInfo":"wz_VcA9B2E"};